export default __webpack_public_path__ + "static/media/YoungGeraldBriefcase400.f5430b08.jpg";